<template>
  <div class="drop-down-rule" data-cy="rule-value-selection">
    <MSelect v-if="currentIdFieldName" v-model="localModel" :items="items" text-field="name" display-field="name" :value-field="currentIdFieldName">
      <template #button-content="{ selectedItem }">
        <slot name="button-content" :entry="selectedItem">
          <div class="status-entry" v-if="selectedItem && selectedItem.color">
            <div class="color-block" :style="{ backgroundColor: `#${selectedItem.color.substring(2, selectedItem.color.length)}` }"></div>
            <div class="entry-text">{{ selectedItem?.name }}</div>
          </div>
          <template v-else>{{ selectedItem?.name }}</template>
        </slot>
      </template>
      <template #item-template="{ entry }">
        <slot :entry="entry">
          <template v-if="Object.hasOwn(entry, 'color')">
            <div class="status-entry">
              <div
                v-if="entry.color"
                class="color-block"
                :style="{ backgroundColor: `#${(<SelectionListModel>entry).color!.substring(2, (<SelectionListModel>entry).color!.length)}` }"></div>
              <div class="entry-text">{{ entry.name }}</div>
            </div>
          </template>
          <template v-else>{{ entry.name }}</template>
        </slot>
      </template>
    </MSelect>
  </div>
</template>
<script setup lang="ts">
import MSelect from "@/BasicComponentLibrary/MSelect.vue";
import { SelectionListModel } from "@medapro-types/AdvancedSearch/components/QueryBuilder";
import _ from "lodash";
import { computed } from "vue";

//#region General
const props = withDefaults(defineProps<{ value: string; items?: Array<SelectionListModel> }>(), {
  items: () => []
});
const emits = defineEmits(["input"]);
//#endregion

//#region items
const currentIdFieldName = computed(() => {
  const firstElement = _.first(props.items);
  if (firstElement) {
    const foundIdName = Object.keys(firstElement).find((x) => x.endsWith("Id"));
    if (foundIdName) return foundIdName;
  }
  return null;
});
//#endregion

//#region Update localModal
const localModel = computed({
  get() {
    return props.value;
  },
  set(nv) {
    emits("input", nv);
  }
});

//#endregion
</script>
